export const config = {
  baseUrl: {
    local: 'http://localhost:3030', // local proxy server
    dev: '//api.global.dev.fileinvite.info', // for actual dev env
    preprod: '//api.global.preprod.fileinvite.info', // for QA preprod
    prod: '//global.fileinvite.app', // for production
  },
  apiVersion: {
    v1: '/2023-02',
  },
  clientId: 2,
  redirectUri: `${globalThis.location.host}/2023-02/callback`,
  turnstile: {
    siteKey:
      process.env['NX_PUBLIC_TURNSTILE_SITE_KEY']?.trim() ||
      '1x00000000000000000000AA', // Cloudflare test site key (works on localhost)
  },
};
